import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SupabaseService } from './supabase.service';
import { UserService } from './user.service';

export interface ReportIssuePayload {
  summary: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class ReportIssueService {
  constructor(
    private supabaseService: SupabaseService,
    private userService: UserService,
    private router: Router
  ) {}

  async report(payload: ReportIssuePayload): Promise<{ issue_url: string }> {
    const user = this.userService.currentUser;
    const clubId = this.supabaseService.clubId;
    const subdomain = window.location.hostname.split('.')[0];

    const { data, error } = await this.supabaseService.supabase.functions.invoke(
      'reportIssue',
      {
        body: {
          user_id: user?.id ?? null,
          user_email: user?.email ?? null,
          club_id: clubId,
          club_subdomain: subdomain,
          summary: payload.summary,
          description: payload.description,
          emitted_at: new Date().toISOString(),
          user_agent: navigator.userAgent,
          page_url: window.location.href,
        },
      }
    );

    if (error) {
      console.error('reportIssue edge function error:', error);
      throw error;
    }

    return data as { issue_url: string };
  }
}
